import React, { useCallback, useEffect, useState } from "react";
import Report from "../../../models/Report";
import DataTable from "../dataTable";

const initialTable = {
    page: 1,
    term: "",
    sort: "order",
    order: "asc",
    limit: 25,
};

export default function TeeTimePaymentMethodMix() {
    const [loading, setLoading] = useState(true);
    const [table, setTable] = useState(initialTable);
    const [totalRecords, setTotalRecords] = useState(0);
    const [data, setData] = useState([]);

    const getData = useCallback(async (params) => {
        setLoading(true);
        const response = await Report.teeTimePaymentMethodMix(params);
        setData(response.items);
        setTotalRecords(response.total);
        setTable(params);
        setLoading(false);
    }, []);

    useEffect(() => {
        getData(initialTable);
    }, [getData]);

    const headers = [
        { key: "paymentMethod", text: "Payment method" },
        { key: "requestCount", text: "Request count" },
        { key: "percentage", text: "% of requests" },
    ];
    const tableData = data.map((item) => {
        const percentage = Number(item.percentage || 0);
        return {
            paymentMethod: {
                value: item.paymentMethod,
                search: item.paymentMethod,
            },
            requestCount: {
                value: item.requestCount,
                search: item.requestCount,
            },
            percentage: {
                value: `${percentage.toFixed(2)}%`,
                search: percentage,
            },
        };
    });

    return (
        <>
            <h4>Tee-time payment method mix</h4>
            <p>
                The all-time split of tee-time requests by Green Fee, GFC, and
                Voucher.
            </p>
            <DataTable
                loading={loading}
                headers={headers}
                data={tableData}
                totalRecords={totalRecords}
                page={table.page}
                onChange={getData}
                searchTerm={table.term}
                sort={table.sort}
                order={table.order}
                limit={table.limit}
                sortOptions={[
                    { text: "Default order", key: "order" },
                    { text: "Payment method", key: "paymentMethod" },
                    { text: "Request count", key: "requestCount" },
                    { text: "% of requests", key: "percentage" },
                ]}
                pagination
            />
        </>
    );
}
